import { render, staticRenderFns } from "./ShowAffiliate.vue?vue&type=template&id=68494650&"
import script from "./ShowAffiliate.vue?vue&type=script&lang=js&"
export * from "./ShowAffiliate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports